import {
	FormItem,
	MoreInfo,
	Select,
	SelectItem,
	TextInput,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { RssFeedType } from "client/Api/Workspace/LiveInformation/Rss/rssLiveInformation";
import { OwnRssAppTab } from "client/Api/Workspace/workspace";
import styles from "./OwnRssTabContent.module.less";

const feedTypeOptions: readonly SelectItem<RssFeedType>[] = [
	{
		text: localize("_PublicRSS"),
		value: RssFeedType.Public
	},
	{
		text: localize("_SharePoint"),
		value: RssFeedType.SharePoint
	}
];

export type OwnRssTabContentProps = {
	ownTabHandler: IValueInputAttachable<OwnRssAppTab>;
	onOpenDialog(): void;
};

export const OwnRssTabContent = (props: OwnRssTabContentProps): ReactElement => {
	const {
		ownTabHandler,
		onOpenDialog
	} = props;

	return (
		<>
			<FormItem
				label={localize("_FeedType")}
			>
				<Select
					{...ownTabHandler.for("feedType").attachToSelect()}
					options={feedTypeOptions}
					menuTitle={localize("_FeedType")}
				/>
			</FormItem>
			<FormItem
				label={localize("_RssFeedUrl")}
			>
				<div className={styles.inputWithInfo}>
					<TextInput {...ownTabHandler.for("feedUrl").attachToTextInput()} />
					{ownTabHandler.value.feedType === RssFeedType.SharePoint && (
						<div className={styles.infoButton}>
							<MoreInfo onClick={onOpenDialog}/>
						</div>
					)}
				</div>
				<ValidationError {...ownTabHandler.for("feedUrl").attachToValidationError()} />
			</FormItem>
			<FormItem
				label={localize("_SiteUrl")}
			>
				<TextInput {...ownTabHandler.for("siteUrl").attachToTextInput()} />
				<ValidationError {...ownTabHandler.for("siteUrl").attachToValidationError()} />
			</FormItem>
			<FormItem
				label={localize("_TabName")}
			>
				<TextInput {...ownTabHandler.for("name").attachToTextInput()} />
				<ValidationError {...ownTabHandler.for("name").attachToValidationError()} />
			</FormItem>
		</>
	);
};

OwnRssTabContent.displayName = "OwnRssTabContent";